export default "__VITE_ASSET__Ds_s9h7u__"